(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakSet();
  let observer;
  function reveal(root = document) {
    if (!reduced.matches && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('prototype-motion');
      observer ||= new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); }
      }), { threshold: .1 });
      root.querySelectorAll('.reveal:not(.visible)').forEach(el => observer.observe(el));
    } else {
      document.documentElement.classList.remove('prototype-motion');
      root.querySelectorAll('.reveal').forEach(el => el.classList.add('visible'));
    }
  }
  function initMenu() {
    const menu = document.getElementById('mobile-nav');
    const toggle = document.getElementById('mobile-toggle');
    if (!menu || !toggle || initialized.has(toggle)) return;
    initialized.add(toggle);
    const label = toggle.getAttribute('aria-label');
    function close(restore = false) {
      menu.classList.remove('open'); toggle.setAttribute('aria-expanded', 'false'); toggle.textContent = '\u2630';toggle.setAttribute('aria-label',label);
      if (restore) toggle.focus();
    }
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', String(open)); toggle.textContent = open ? '\u00d7' : '\u2630';
      toggle.setAttribute('aria-label', open ? toggle.dataset.closeLabel : label);
    });
    menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => close()));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && menu.classList.contains('open')) close(true); });
    document.addEventListener('click', e => { if (!menu.contains(e.target) && !toggle.contains(e.target)) close(); });
    document.addEventListener('focusin', e => { if (!menu.contains(e.target) && e.target !== toggle) close(); });
  }
  function initRitual(section) {
    if (initialized.has(section)) return;
    initialized.add(section);
    const tabs = [...section.querySelectorAll('[data-ritual]')];
    const templates = [...section.querySelectorAll('[data-ritual-content]')];
    const panel = section.querySelector('[role="tabpanel"]');
    function choose(btn) {
      tabs.forEach(b => { b.classList.toggle('on', b === btn); b.setAttribute('aria-selected', String(b === btn)); b.tabIndex = b === btn ? 0 : -1; });
      const content = templates[Number(btn.dataset.ritualIndex)].content;
      section.querySelector('[data-ritual-title]').innerHTML = content.querySelector('h3').innerHTML;
      section.querySelector('[data-ritual-description]').textContent = content.querySelector('p').textContent;
      const key = btn.dataset.ritual;
      section.querySelector('[data-ritual-visual]').className = 'ritual-visual' + (key === 'sun' ? '' : ' ' + key);
      panel.setAttribute('aria-labelledby', btn.id);
    }
    tabs.forEach((btn, index) => {
      btn.addEventListener('click', () => choose(btn));
      btn.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); choose(tabs[next]); tabs[next].focus(); }
      });
    });
    if (tabs.length) choose(tabs[0]);
  }
  function init(root = document) {
    reveal(root); initMenu();
    root.querySelectorAll('[data-ritual-section]').forEach(initRitual);
  }
  init();
  reduced.addEventListener('change', () => reveal());
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:select', event => event.target.querySelectorAll('.reveal').forEach(el => el.classList.add('visible')));
  document.addEventListener('shopify:block:select', event => {
    const tab = event.target.closest('[data-ritual]');
    if (tab) tab.click();
    event.target.classList.add('visible');
  });
})();
